export enum VideoQualityEnum {
  BitrateControl = 0, // Covers -b:v, -maxrate, -bufsize (CBR/VBR)
  ConstantQuality = 1, // Covers -crf (Quality-based VBR)
  FixedQuantizer = 2, // Covers -qp (Overrides CRF)
}

export type VideoQuality =
  | VideoQualityEnum.BitrateControl
  | VideoQualityEnum.ConstantQuality
  | VideoQualityEnum.FixedQuantizer;
